export const productionno = (productionno) => ({
  type: "SET_SELECTED_PRODUCTIONNO",
  payload: productionno,
});
